/*------------------------------------*\
    MODULES
\*------------------------------------*/
import Flickity from 'flickity';

/*------------------------------------*\
    HERO CAROUSEL
\*------------------------------------*/
class HeroCarousel {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;
        self.carousel();
    }

    carousel() {
        let self = this;

        self.flkty = new Flickity(self.elem, {
            prevNextButtons: true,
            wrapAround: true,
            autoPlay: 5000,
            pageDots: false
        });
    }


}
/*
var elem = document.querySelector('.carousel');
var flkty = new Flickity(elem, {
  // options
  cellAlign: 'left',
  contain: true
});
*/
export default HeroCarousel;